import { useEffect, useState } from "react";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { Profile } from "@/models/database/profiles/profile.model";
import { PrecisionGameLeaderboard } from "@/features/precisionGame/models/precisionGame.types";

export const useTenantsPrecisionGameCount = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [count, setCount] = useState<Number>();
  const [hasWon, setHasWon] = useState<Number>(0);

  const fetchProfiles = async () => {
    try {
      setLoading(true);
      const profiles: PrecisionGameLeaderboard[] = [];

      const ref = collectionRef.precisionGame(
        brand.tenantId,
        "gamebox-2025-ps5-raffle"
      );
      const query = await ref.get();

      query.docs.map(async (doc) => {
        profiles.push(doc.data());
      });

      // Extract unique UIDs from the profiles array
      const uniqueUids = new Set(profiles.map((profile) => profile.uid));
      const numberOfUniqueProfiles = uniqueUids.size;

      // Count unique users with score 1337
      const usersWithWinningScore = new Set();
      profiles.forEach((profile) => {
        if (profile.score === 1337) {
          usersWithWinningScore.add(profile.uid);
        }
      });
      const winnersCount = usersWithWinningScore.size;

      setCount(numberOfUniqueProfiles);
      setHasWon(winnersCount);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!count) {
      fetchProfiles();
    }
  }, [brand.tenantId]);

  return {
    data: count,
    hasWon,
    loading,
    error,
  };
};
